import React, { useState, useEffect } from "react";
import { Switch, Checkbox, Row, Col, Collapse, Form } from "antd";
// style
import styles from "./form.module.css";

const { Panel } = Collapse;

const SystemManagerAdminForm = ({
  disabledState,
  getFieldValue,
  setFieldsValue,
  isAdmin,
}) => {
  const [endUserAccess, setEndUserAccess] = useState(
    getFieldValue("sm_end_user_access"),
  );
  const [adminAccess, setAdminAccess] = useState(
    getFieldValue("sm_solution_access"),
  );

  useEffect(() => {
    setEndUserAccess(getFieldValue("sm_end_user_access"));
  }, [getFieldValue("sm_end_user_access")]);

  useEffect(() => {
    setAdminAccess(getFieldValue("sm_solution_access"));
  }, [getFieldValue("sm_solution_access")]);

  const smSolutionAccessOnChange = (value) => {
    setAdminAccess((prevValue) => !prevValue);
    setFieldsValue({ sm_solution_access: value });
    if (value) {
      setEndUserAccess(false);
      setFieldsValue({
        sm_end_user_access: !value,
        sm_user_managment: !value,
        sm_onboarding_automation: !value,
      });
    } else {
      setFieldsValue({
        sm_hmg_delete: value,
        sm_hotel_delete: value,
        sm_pms_delete: value,
        sm_role_delete: value,
        sm_report_delete: value,
      });
    }
  };

  const smEndUserAccessOnChange = (value) => {
    setEndUserAccess((prevValue) => !prevValue);
    setFieldsValue({
      sm_user_managment: value,
      sm_end_user_access: value,
    });
    if (value) {
      setAdminAccess(false);
      setFieldsValue({
        sm_solution_access: !value,
        sm_hmg_delete: !value,
        sm_hotel_delete: !value,
        sm_pms_delete: !value,
        sm_role_delete: !value,
        sm_report_delete: !value,
      });
    } else {
      setFieldsValue({
        sm_report_category: false,
        sm_hotels_management: false,
        sm_report_management: false,
        sm_barcode_management: false,
        sm_onboarding_automation: false,
      });
    }
  };
  return (
    <Collapse defaultActiveKey={["2_2"]} expandIconPosition="end">
      <Panel header="System Manager" key="2_2">
        <div className="is_form_2_a">
          {isAdmin && (
            <div className="is_form_2_aa">
              <div className="is_form_2_aa">
                <Row>
                  <Col
                    xxl={3}
                    xl={4}
                    lg={5}
                    md={5}
                    sm={5}
                    xs={24}
                    className={styles.label}
                  >
                    <label>Admin Access</label>
                  </Col>

                  <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="sm_solution_access"
                      valuePropName="checked"
                    >
                      <Switch
                        disabled={
                          !!(
                            disabledState ||
                            getFieldValue("sm_end_user_access") === true
                          )
                        }
                        onChange={smSolutionAccessOnChange}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <Row>
                <Col
                  xxl={3}
                  xl={4}
                  lg={5}
                  md={5}
                  sm={5}
                  xs={24}
                  className={styles.label}
                >
                  <label>HMG</label>
                </Col>
                <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                  <Form.Item
                    style={{
                      borderBottom: "none",
                    }}
                    name="sm_hmg_delete"
                    valuePropName="checked"
                  >
                    <Checkbox
                      disabled={
                        disabledState || !getFieldValue("sm_solution_access")
                      }
                    >
                      Delete
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col
                  xxl={3}
                  xl={4}
                  lg={5}
                  md={5}
                  sm={5}
                  xs={24}
                  className={styles.label}
                >
                  <label>Hotel</label>
                </Col>
                <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                  <Form.Item
                    style={{
                      borderBottom: "none",
                    }}
                    name="sm_hotel_delete"
                    valuePropName="checked"
                  >
                    <Checkbox
                      disabled={
                        disabledState || !getFieldValue("sm_solution_access")
                      }
                    >
                      Delete
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col
                  xxl={3}
                  xl={4}
                  lg={5}
                  md={5}
                  sm={5}
                  xs={24}
                  className={styles.label}
                >
                  <label>PMS</label>
                </Col>
                <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                  <Form.Item
                    style={{
                      borderBottom: "none",
                    }}
                    name="sm_pms_delete"
                    valuePropName="checked"
                  >
                    <Checkbox
                      disabled={
                        disabledState || !getFieldValue("sm_solution_access")
                      }
                    >
                      Delete
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col
                  xxl={3}
                  xl={4}
                  lg={5}
                  md={5}
                  sm={5}
                  xs={24}
                  className={styles.label}
                >
                  <label>Role</label>
                </Col>
                <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                  <Form.Item
                    style={{
                      borderBottom: "none",
                    }}
                    name="sm_role_delete"
                    valuePropName="checked"
                  >
                    <Checkbox
                      disabled={
                        disabledState || !getFieldValue("sm_solution_access")
                      }
                    >
                      Delete
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col
                  xxl={3}
                  xl={4}
                  lg={5}
                  md={5}
                  sm={5}
                  xs={24}
                  className={styles.label}
                >
                  <label>Report</label>
                </Col>
                <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                  <Form.Item
                    style={{
                      borderBottom: "none",
                    }}
                    name="sm_report_delete"
                    valuePropName="checked"
                  >
                    <Checkbox
                      disabled={
                        disabledState || !getFieldValue("sm_solution_access")
                      }
                    >
                      Delete
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            </div>
          )}

          <div className="is_form_2_aa">
            <div className="is_form_2_aaa">
              <Row>
                <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                  <label>End User Access</label>
                </Col>
                <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                  <Form.Item
                    style={{
                      borderBottom: "none",
                    }}
                    name="sm_end_user_access"
                    valuePropName="checked"
                  >
                    <Switch
                      disabled={
                        !!(
                          disabledState ||
                          getFieldValue("sm_solution_access") === true
                        )
                      }
                      onChange={smEndUserAccessOnChange}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <Row>
              <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                <label>User Management</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  style={{
                    borderBottom: "none",
                  }}
                  name="sm_user_managment"
                  valuePropName="checked"
                >
                  <Checkbox disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                <label>Report Management</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  style={{
                    borderBottom: "none",
                  }}
                  name="sm_report_management"
                  valuePropName="checked"
                >
                  <Checkbox
                    disabled={
                      disabledState || !getFieldValue("sm_end_user_access")
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                <label>Report Category</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  style={{
                    borderBottom: "none",
                  }}
                  name="sm_report_category"
                  valuePropName="checked"
                >
                  <Checkbox
                    disabled={
                      disabledState || !getFieldValue("sm_end_user_access")
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                <label>Hotels</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  style={{
                    borderBottom: "none",
                  }}
                  name="sm_hotels_management"
                  valuePropName="checked"
                >
                  <Checkbox
                    disabled={
                      disabledState || !getFieldValue("sm_end_user_access")
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                <label>Barcode Download</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  style={{
                    borderBottom: "none",
                  }}
                  name="sm_barcode_management"
                  valuePropName="checked"
                >
                  <Checkbox
                    disabled={
                      disabledState || !getFieldValue("sm_end_user_access")
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Onboarding Automation</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  style={{
                    borderBottom: "none",
                  }}
                  name="sm_onboarding_automation"
                  valuePropName="checked"
                >
                  <Checkbox
                    disabled={
                      disabledState || !getFieldValue("sm_end_user_access")
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>
      </Panel>
    </Collapse>
  );
};

export default SystemManagerAdminForm;
